import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [form, setForm] = useState({});
  const navigate = useNavigate();


  useEffect(() => {
  if (localStorage.getItem("token")) {
    navigate("/dashboard");
  }
}, []);
  const login = async () => {
    try {
      const res = await axios.post(
        "https://mdqapps.online/qrgen_api/api/login.php",
        form
      );

      console.log(res.data);

      if (res.data.status === "success") {
        localStorage.setItem("token", res.data.token);
        navigate("/dashboard");
      } else {
        alert("Login Failed");
      }
    } catch (err) {
      console.error("FULL ERROR:", err);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Login</h2>

        <input
          style={styles.input}
          placeholder="Username"
          onChange={e =>
            setForm({ ...form, username: e.target.value })
          }
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          onChange={e =>
            setForm({ ...form, password: e.target.value })
          }
        />

        <button style={styles.button} onClick={login}>
          Login
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #0f172a, #1e3a8a)",
  },
  card: {
    background: "#0f172a",
    padding: "40px",
    borderRadius: "16px",
    width: "320px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
    textAlign: "center",
  },
  title: {
    color: "#fff",
    marginBottom: "25px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #334155",
    background: "#020617",
    color: "#fff",
    outline: "none",
    fontSize: "14px",
  },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    transition: "0.3s",
  },
};